import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { HouseholdStatus } from '../../../common/src/model.ts';
import { getOnboardingPath, OnboardingPages } from '../../../common/src/pages.ts';
import { useHousehold } from '../data/use_household.tsx';
import { AppStoreUrl, getAppStoreUrl, isInsideMobileApp, useAppUpdateNeeded } from './billing.ts';
import { getPlatform, Platform } from './platform.ts';

export const SignUpButton = ({ subscribeButton }: { subscribeButton?: boolean }) => {
  const { household } = useHousehold();
  const householdStatus = household?.status;
  const navigate = useNavigate();
  let message = 'Sign Up';
  let href = getOnboardingPath();
  let isGlobalNavigation = false;
  const appUpdateNeeded = useAppUpdateNeeded();
  if (!isInsideMobileApp() && getPlatform() === Platform.Mobile) {
    message = 'Get App';
    // Platform.Mobile means the device is iOS or Android, so getAppStoreUrl() is always defined here (#3567)
    href = getAppStoreUrl() ?? AppStoreUrl;
    isGlobalNavigation = true;
  } else if (appUpdateNeeded) {
    message = 'Update';
    href = AppStoreUrl; // useAppUpdateNeeded is iOS-only; an Android threshold needs a per-platform link (#3567)
    isGlobalNavigation = true;
  } else if (subscribeButton || householdStatus === HouseholdStatus.Unsubscribed) {
    message = 'Subscribe';
    href = getOnboardingPath(OnboardingPages.SubscribeStart);
  }
  const onClick = useCallback(
    async (event: any) => {
      event.stopPropagation(); // prevent settings page from handling event as well
      if (isGlobalNavigation) {
        window.location.href = href;
        return;
      }
      await navigate(href);
    },
    [href, isGlobalNavigation, navigate],
  );
  return <SignUpButtonStyle onClick={onClick}>{message}</SignUpButtonStyle>;
};

export const OptInButton = ({ onClick }: { onClick: () => void }) => {
  return <SignUpButtonStyle onClick={onClick}>Opt In</SignUpButtonStyle>;
};

const SignUpButtonStyle = styled.button`
  font-family: Jost-SemiBold, Arial, sans-serif;
  font-size: 1.1rem;
  color: white;
  background-color: #5200bb;
  padding: 3px 12px;
  border-radius: 30px;
  margin-right: 8px;
  cursor: pointer;
  text-wrap: nowrap;
`;
